import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.LISTS)({
    component: ListsLayout,
    staticData: {
        config: {
            title: "leads",
            breadcrumb: { title: "leads", to: APP_ROUTES_TO.LISTS },
        },
        permissions: [PERMISSIONS.CALL_SETTING_LISTS],
    },
});

function ListsLayout() {
    return (
        <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden lg:h-auto lg:flex-none lg:overflow-visible">
            <Outlet />
        </div>
    );
}
